import { render } from "./LineItem.vue?vue&type=template&id=2bbfd3da"
import script from "./LineItem.vue?vue&type=script&lang=js"
export * from "./LineItem.vue?vue&type=script&lang=js"
script.render = render

export default script